import { useEffect, useState } from "react";
import {
    AccountCustomerClubDetailDto,
    AccountScoreLevelDefinition,
    AccountService,
} from "../../../api/psc";

export default function useAccountLoyaltyData() {
    const [levels, setLevels] = useState<AccountScoreLevelDefinition[]>();
    const [accountLoyalty, setAccountLoyalty] =
        useState<AccountCustomerClubDetailDto>();
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        Promise.all([
            AccountService.getCustomerLoyaltyDetail("1"),
            AccountService.getLoyaltyLevels("1"),
        ]).then((r) => {
            setAccountLoyalty(r[0]);
            setLevels(r[1]);
            setIsFetching(false);
        });
    };

    return { levels, accountLoyalty, isFetching };
}
